// import { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import Layout from './components/layout/Layout';
import EvaluatePage from './components/evaluate/EvaluatePage';
import AdminPage from './components/admin/AdminPage';
import LoginPage from './components/admin/LoginPage';
import ProtectedRoute from './components/common/ProtectedRoute';
import { generateID } from './utils/idGenerator';


const EvaluateRedirect = () => {
  const location = useLocation();
  const id = generateID();
  return <Navigate to={`/${id}${location.search}`} replace />;
};

function App() {

  return (
    <Router basename="/evaluate">
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<EvaluateRedirect />} />

          {/* Redirect /evaluate to /evaluate/{id} --> <Route path="evaluate" element={<EvaluateRedirect />} /> */}

          {/* Main routes */}
          <Route path=":id" element={<EvaluatePage />} />
          <Route path="admin" element={<ProtectedRoute><AdminPage /></ProtectedRoute>} />
          <Route path="login" element={<LoginPage />} />

          {/* Admin routes */}
        </Route>
      </Routes>
    </Router>
  );
}

export default App;
